import { cacheConfig, http } from '../helpers/axiosHelper';

export default class PolicyService {
   async getPolicies() {
      return http.get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/policy', { ...cacheConfig }).then((response) => {
         return response.data;
      });
   }

   async postPolicyable(policyId: Number, policyableId: Number, policyableType: String, allowed: Number) {
      return await http
         .post(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/policyable', {
            policy_id: policyId,
            policyable_id: policyableId,
            policyable_type: policyableType,
            allowed: allowed,
         })
         .then((response) => {
            return response.data;
         });
   }

   async patchPolicyable(policyableId: Number, allowed: string, path: String) {
      return await http
         .patch(import.meta.env.VITE_APP_API_BASE_URL_DATA + `/policyable/${policyableId}`, [{ op: 'replace', path: path, value: allowed }])
         .then((response) => {
            return response.data;
         });
   }

   async deletePolicyable(policyableId: Number) {
      return await http.delete(import.meta.env.VITE_APP_API_BASE_URL_DATA + `/policyable/${policyableId}`).then((response) => {
         return response.data;
      });
   }
}
